import { useQuery } from '@tanstack/react-query'
import { getTicketSummary } from '../api/ticketRequestApi'

/** KPI özeti — kapsam-geneli; liste filtrelerinden bağımsız (kendi sorgusu). */
export function useTicketSummary() {
  return useQuery({
    queryKey: ['ticket-summary'],
    queryFn: getTicketSummary,
  })
}
